import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  polls: [],
  tags: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setPolls = (state, payload) => (
  object.setIn(state, [ 'polls' ], payload)
)

export const setTags = (state, payload) => (
  object.setIn(state, [ 'tags' ], payload)
)
